<template>
  <div ref="myElement" class="search-box">
    <div v-if="isDesktopSize" class="desktop-size">
      <search-item
      ></search-item>
    </div>
    <div v-else class="mobile-size">
      <button class="button-toggle" @click="toggle">
        <img
          :src="'/static/icons/booking-icon.svg'"
          class="book-icon search-icon"
        />
        <div class="search-title">ค้นหาห้องประชุม</div>
        <img
          v-if="!isActive"
          :src="'/static/icons/arrow-down.svg'"
          class="book-icon arrow"
        />
        <img
          v-if="isActive"
          :src="'/static/icons/arrow-up.svg'"
          class="book-icon arrow"
        />
      </button>
      <slide-up-down
        :active="isActive"
        :use-hidden="useHidden"
        :class="timing"
        :duration="duration"
        class="AccordionWrapper"
      >
        <search-item></search-item>
      </slide-up-down>
    </div>
  </div>
</template>

<script>
import SlideUpDown from "vue-slide-up-down";
import SearchItem from "./SearchItem";
import { lSize } from "../VariableStatic";

export default {
  components: {
    "slide-up-down": SlideUpDown,
    "search-item": SearchItem,
  },
  props: [],
  data() {
    return {
      roomTypeSelect: null,
      roomDateRangeSelect: null,
      numberOfPeopleSelect: null,
      timeDurationSelect: null,
      roomTypeList: [],
      active: true,
      show: true,
      contentLength: 2,
      showOptions: true,
      useHidden: true,
      timing: "",
      duration: 500,
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    isDesktopSize() {
      return this.windowWidth >= lSize;
    },
    isActive() {
      return this.active;
    },
  },
  watch: {
    duration() {
      this.duration = parseInt(this.duration, 10);
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    toggle() {
      this.active = !this.active;
    },
    toggleShow() {
      this.show = !this.show;
    },
    toggleShowOptions() {
      this.showOptions = !this.showOptions;
    },
    addContent() {
      this.contentLength += 1;
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style lang='scss' scoped>
@import "../../css/otherWebVariables";

.search-box {
  left: 0;
  right: 0;
  top: 0;
  height: 100%;
  width: 95%;
  background-color: $white;
  margin: auto;
  border-radius: 15px;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.2);
  font-size: $font-14;
  color: $color-gray;
  position: sticky;
  position: -webkit-sticky;
  z-index: 10;
}

.row-box {
  padding: 30px;
}

.col-box {
  text-align: left;
  padding-bottom: 10px;
}

.el-full {
  width: 100%;
}

.button-toggle {
  width: 100%;
  height: 50px;
  border: 0;
  background-color: $color-orange;
  cursor: pointer;
  text-align: left;
}

.desktop-size {
  width: 100%;
}

.book-icon {
  padding-right: 15px;
}

.mobile-size {
  width: 100%;
}

.search-title {
  font-size: $font-20;
  display: inline;
  color: $white;
  line-height: 35px;
}

.arrow {
  position: absolute;
  right: 0;
  top: 20px;
  z-index: 100;
}

.AccordionWrapper {
}

@media screen and (max-width: $m-size) {
  .search-box {
    width: 100%;
    font-size: $font-14;
    border-radius: 0px;
  }

  button {
    border-radius: 0px;
  }

  .search-icon {
    width: 38px;
    margin-bottom: 7px;
  }
}
</style>